function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Features",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3322",
    d: "m19797.984 22659.262.268-1.58-1.143-1.115a.35.35 0 0 1 .188-.6l1.586-.227.711-1.439a.345.345 0 0 1 .621 0l.705 1.439 1.592.227a.355.355 0 0 1 .193.6l-1.148 1.115.268 1.58a.345.345 0 0 1-.342.4.379.379 0 0 1-.164-.039l-1.416-.746-1.422.746a.356.356 0 0 1-.162.041.343.343 0 0 1-.335-.402zm7.615-.869a.7.7 0 1 1 0-1.395h9a.7.7 0 1 1 0 1.395zm-4.281-5.875-1.416-.744-1.422.744a.342.342 0 0 1-.5-.363l.268-1.582-1.143-1.119a.346.346 0 0 1 .188-.592l1.586-.234.711-1.432a.345.345 0 0 1 .621 0l.705 1.432 1.592.234a.351.351 0 0 1 .193.592l-1.148 1.119.268 1.582a.344.344 0 0 1-.342.4.445.445 0 0 1-.161-.037zm4.281-1.324a.7.7 0 1 1 0-1.395h9a.7.7 0 1 1 0 1.395z",
    transform: "translate(-19794.102 -22641.305)",
    style: {
      fill: "#3a4043"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatures);
export default __webpack_public_path__ + "static/media/IconFeatures.d6ead1dbdd0cbcadc920ede9e080c4a0.svg";
export { ForwardRef as ReactComponent };